import _ from 'lodash'
import config from '@/config'
import * as signalR from '@microsoft/signalr'
import * as msgPackProtocol from '@microsoft/signalr-protocol-msgpack'
let connection = null
export default {
  namespaced: true,
  state: {
    online: false,
    messageCb: []
  },
  mutations: {
    attachEvtListener: (state, callback) => {
      state.messageCb.push(callback)
    },
    dettachEvtListener: (state, callback) => {
      const index = _.findIndex(state.messageCb, o => o === callback)
      state.messageCb.splice(index, 1)
    },
    setOnlineState: (state, onlineState) => {
      state.online = onlineState
    }
  },
  actions: {
    startSignalr: ({ state, rootState, commit }) => {
      const token = (rootState.auth && rootState.auth[config.tokenName]) || ''
      if (!token) {
        return
      }
      connection = new signalR.HubConnectionBuilder()
        .withUrl(`${config.baseURL}messageHub`, {
          accessTokenFactory: () => token
        })
        .withHubProtocol(new msgPackProtocol.MessagePackHubProtocol())
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: (retryContext) => {
            return 10 * 1000
          }
        })
        .configureLogging(signalR.LogLevel.Information)
        .build()
      connection.onclose(() => {
        commit('setOnlineState', false)
      })
      connection.onreconnecting(connectionId => {
        commit('setOnlineState', false)
        console.log('connectionId ', connectionId, ' reconnecting')
      })
      connection.onreconnected(connectionId => {
        commit('setOnlineState', true)
        console.log('connectionId ', connectionId, ' has reconnected')
      })
      connection.on('ReceiveMessage', (message) => {
        state.messageCb.forEach(cb => {
          cb(message)
        })
      })
      connection.start().then(() => {
        commit('setOnlineState', true)
      }).catch((ex) => {
        console.log(ex)
      })
    },
    attachEvtListener: ({ commit }, callback) => {
      commit('attachEvtListener', callback)
    },
    dettachEvtListener: ({ commit }, callback) => {
      commit('dettachEvtListener', callback)
    },
    stopSignalr: () => {
      return new Promise((resolve) => {
        if (connection) {
          connection.off('ReceiveMessage')
          connection.stop()
          connection = null
        }
        resolve(true)
      })
    }
  }
}
